(() => {
  let lastOpenTrigger;

  const restoreOpenTrigger = () => {
    if (!lastOpenTrigger) return;
    const trigger = lastOpenTrigger;
    lastOpenTrigger = undefined;
    requestAnimationFrame(() => {
      if (typeof window.SHTHelper?.removeTrapFocus === 'function') {
        window.SHTHelper.removeTrapFocus(trigger);
      } else if (document.activeElement !== trigger) {
        trigger.focus({ preventScroll: true });
      }
    });
  };

  const openSearch = (event, trigger) => {
    const search = document.querySelector('.js-predictive-search');
    const input = search?.querySelector('.js-predictive-search-input');
    if (!search || !input) return;
    event.preventDefault();
    lastOpenTrigger = trigger;
    if (search.elms) search.elms.header_search_open_trigger = trigger;
    if (typeof search.toggleOpen === 'function') search.toggleOpen(true);
    else {
      search.toggleAttribute('open', true);
      document.body.classList.add('header--predictive-search-open', 'o-hidden');
    }
    const focusInput = () => {
      if (!search.hasAttribute('open')) return;
      try {
        window.SHTHelper?.trapFocus?.(search, input);
      } catch (error) {
        console.warn('[PredictiveSearch] trapFocus failed:', error);
      }
      if (document.activeElement !== input) input.focus({ preventScroll: true });
    };
    // Focus immediately for keyboard users, then confirm it once the opened
    // search has painted. This also survives browser focus changes during the
    // header transition without making navigation wait for that animation.
    focusInput();
    requestAnimationFrame(focusInput);
    setTimeout(focusInput, 100);
    // The native header completes its transition at 650ms and runs its own
    // focus trap. Confirm focus just after that transition without blocking
    // the native trigger listener.
    setTimeout(focusInput, 700);
  };

  document.addEventListener('click', (event) => {
    const close = event.target.closest('.js-predictive-search-close-trigger');
    if (close && lastOpenTrigger) {
      restoreOpenTrigger();
      return;
    }
    const trigger = event.target.closest('.js-search-open-trigger');
    if (trigger) openSearch(event, trigger);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const search = document.querySelector('.js-predictive-search[open]');
    if (!search) return;
    event.preventDefault();
    if (typeof search.closeSearchResults === 'function') search.closeSearchResults();
    else if (typeof search.toggleOpen === 'function') search.toggleOpen(false);
    else {
      search.removeAttribute('open');
      document.body.classList.remove('header--predictive-search-open', 'o-hidden');
    }
    restoreOpenTrigger();
  }, true);
})();
